<!-- 产品 -->
<template>
  <div ref="project" class="project">
    <div style="overflow:hidden;">
      <div ref="htmlInner" v-html="arrList.content"></div>
    </div>
    <!-- 底部 定制 -->
    <div class="styleBox_07" :style="{backgroundImage:'url('+ bgUrl +')'}">
      <p>智能化网络安全保障服务，即刻开启！</p>
      <a href="javascript:void(0);" class="comButton collection-1 btn-15">
        <span @click="toPlan">立即定制</span>
      </a>
    </div>
  </div>
</template>
<script>
import Header from '@/components/comForPc/header.vue'
import Sidebar from '@/components/comForPc/sidebar.vue'
import Footer from '@/components/comForPc/footer.vue'
// import swiperGo from '@/utils/swiper'
export default {
  components: { Header, Sidebar, Footer },
  data () {
    return {
      arrList: [],
      index: 0,
      bgUrl: '',
      bgUrl2: ''
    }
  },
  methods: {
    getInfo () {
      let pageId = this.$route.query.id ? this.$route.query.id : ''
      let infoId = this.$route.query.childId ? this.$route.query.childId : ''
      let arr = JSON.parse(localStorage.getItem('navList'))
      arr.forEach(item => {
        if (item.id == pageId) {
          item.articleList.forEach(items => {
            if (items.id == infoId) {
              this.arrList = items
            }
          })
        }
      })
      this.appendJs()
    },
    toPlan () {
      this.$router.push('/getPlan')
    },
    appendJs () {
      let _self = this
      this.$nextTick(() => {
        var ele = document.createElement('script')
        ele.innerHTML = 'var items = document.querySelectorAll(".item");' +
          'var left = document.getElementById("clickL");' +
          'var right = document.getElementById("clickR");' +
          'var index = 0;' +
          'var goIndex = function() {' +
            'clearActive();' +
            'items[index].className = "item active";' +
          '};' +
          'left.onclick = function(){' +
            'if (index == 0) {' +
              'index = 4;' +
            '} else {' +
              'index--;' +
            '}' +
            'goIndex();' +
          '};' +
          'right.onclick = function(){' +
            'if (index < 4) {' +
            '    index++;' +
            '} else {' +
            '    index = 0;' +
            '};' +
            'goIndex();' +
          '};' +
          'function clearActive () {' +
            'for (i = 0; i < items.length; i++) {' +
              'items[i].className = "item";' +
            '};' +
          '};'
        _self.$refs.htmlInner.append(ele)
      })
    }
  },
  mounted () {
    this.bgUrl = this.$axios.defaults.baseURL + '/u/20230101/img_gg_1672576300037.jpg'
    this.bgUrl2 = this.$axios.defaults.baseURL + '/u/20230116/building-bg备份 2_1673860609653.png'
    this.getInfo()
  },
  destroyed () {
  },
  watch: {
    $route: {
      handler (newVal, oldVal) {
        this.getInfo()
      }
    },
    arrList: {
      handler (newVal, oldVal) {
        // this.$nextTick(() => {
        //   setTimeout(function () {
        //     swiperGo()
        // }, 1000)
        // swipreGo()
        // debugger
        // })
      }
    }
  }
}
</script>
<style lang="less" scoped>
// 移动端样式
@media only screen and (max-width: 1024px) {
  .project {
    padding-top: 2.75rem;
  }
  .styleBox_07 {
    width: 100%;
    background-repeat:no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2.125rem 0 1.5625rem;
  }
  .styleBox_07 p {
    font-size: 1rem;
    font-weight: 600;
    color: #08142a;
    margin-bottom: 1.5625rem;
  }
  .comButton {
    color: #fff;
    border-radius: 1rem;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    padding: 0;
    height: 1.875rem;
    font-size: 0.8125rem;
    margin: 0;
    padding: 0;
    max-width: 6.6875rem;
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
  .project_03 {
    width: 100%;
    background-repeat: no-repeat;
    padding: 3.75rem 0 4.75rem;
    overflow: hidden;
    position: relative;
    background-size: 100%;
  }
  .project_03_inner {
    display: flex;
  }

  .project_03_inner div {
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    padding: 0 3.375rem;
    box-sizing: border-box;
    display: none;
  }
  .project_03_inner div p {
    min-height: 90px;
  }
  .clickL,
  .clickR {
    width: 2.5rem;
    height: 2.5rem;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 100%;
    position: absolute;
    top: 50%;
    cursor: pointer;
    text-align: center;
  }
  .clickL {
    left: 1rem;
  }
  .clickR {
    right: 1rem;
  }
  .project_03 .icon {
    font-size: 1.125rem;
    color: #fff;
    line-height: 2.5rem;
  }
  .project_03_inner .active {
    display: flex;
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  .project {
    background: #fff;
  }
  .styleBox_07 {
    width: 100%;
    height: 320px;
    background-repeat:no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .styleBox_07 p {
    font-size: 32px;
    font-weight: 600;
    color: #08142a;
    margin-bottom: 44px;
  }
  .comButton {
    color: #fff;
    border-radius: 28px;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
    padding: 0;
    height: 50px;
    font-size: 18px;
  }
  .btn-15:after {
    background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product.vue